import {IFeatureLayerInfo, IQuery} from '../interfaces/models'
const sql =
  '((Status > 9 OR Status < 6) AND ((Status = 3 OR Status = 5) OR Status = 1 OR Status IN (1,2,3))) AND Status IN (1,2,3) AND (Status = 6)'

const getBrakets = (sql: string): {[key: string]: number} => {
  const brakets: {[key: string]: number} = {}
  const opening: Array<number> = []
  for (let i = 0; i < sql.length; i++) {
    if (sql[i] == ')') {
      brakets[opening.pop()!] = i
    } else if (sql[i] == '(') {
      opening.push(i)
    }
  }
  if (opening.length > 0) {
    throw new Error('not all brakets are closed')
  }
  return brakets
}

const handleBrakets = (
  brakets: {[key: string]: number},
  rootAndPrimitives: {rootSql: string; primitives: {[key: string]: string}}
): {rootSql: string; primitives: {[key: string]: string}} => {
  const sql = rootAndPrimitives.rootSql
  const primitives = rootAndPrimitives.primitives
  let index = Object.keys(primitives).length + 1
  const getPrimitive = (
    brakets: {[key: string]: number},
    sql: string
  ): {brakets: {[key: string]: number}; rootSql?: string} => {
    for (const openIndexStr in brakets) {
      const openIndex = parseInt(openIndexStr)
      let found = true
      for (const i in brakets) {
        if (parseInt(i) > openIndex) {
          found = false
          break
        }
      }
      if (found) {
        const braketsOpenIndex = brakets[openIndex]
        delete brakets[openIndex]
        const id = '<id' + index + '>'
        const content = sql.substring(openIndex, braketsOpenIndex + 1)
        const rootSql = sql.substring(0, openIndex) + id + sql.substring(braketsOpenIndex + 1)
        const contentDifference = id.length - content.length

        const newBrakets = {...brakets}
        for (const i in brakets) {
          if (parseInt(i) > braketsOpenIndex) {
            if (brakets[i] > braketsOpenIndex) {
              newBrakets[parseInt(i) + contentDifference] = brakets[i] + contentDifference
            } else {
              newBrakets[parseInt(i) + contentDifference] = brakets[i]
            }
          } else {
            if (brakets[i] > braketsOpenIndex) {
              newBrakets[i] = brakets[i] + contentDifference
            } else {
              newBrakets[i] = brakets[i]
            }
          }
        }
        brakets = newBrakets
        index++
        primitives[id] = content
        return {brakets: brakets, rootSql: rootSql}
      }
    }

    return {brakets: brakets, rootSql: undefined}
  }

  let res: {brakets: {[key: string]: number}; rootSql?: string} = {rootSql: sql, brakets: brakets}
  while (res.rootSql) {
    const preRes = getPrimitive(res.brakets, res.rootSql)
    if (!preRes.rootSql) {
      return {rootSql: res.rootSql, primitives: primitives}
    }
    res = {rootSql: preRes.rootSql, brakets: preRes.brakets}
  }
  return {rootSql: res.rootSql!, primitives: primitives}
}

const getOperators = (primitive: string): Array<string> => {
  const operators: Array<string> = []
  const ands = (primitive.match(/ AND /g) || []).length
  for (let i = 0; i < ands; i++) {
    operators.push(' AND ')
  }
  const ors = (primitive.match(/ OR /g) || []).length
  for (let i = 0; i < ors; i++) {
    operators.push(' OR ')
  }
  const ins = (primitive.match(/ IN /g) || []).length
  for (let i = 0; i < ins; i++) {
    operators.push(' IN ')
  }
  return operators
}

const breakComplexity = (primitives: {[key: string]: string}, newPrimitives: {[key: string]: string}) => {
  let index = Object.keys(newPrimitives).length
  for (const j in primitives) {
    let primitive = primitives[j]
    primitive = primitive.replace(/\(/g, '').replace(/\)/g, '')
    const operators = getOperators(primitive)
    if (operators.length > 1) {
      const strIndex = primitive.indexOf(operators[0])
      const primitive1 = primitive.slice(0, strIndex)
      const primitive2 = primitive.slice(strIndex + operators[0].length, primitive.length)
      const id1 = '<id' + index + '>'
      index++
      const id2 = '<id' + index + '>'
      index++
      newPrimitives[j] = id1 + operators[0] + id2
      newPrimitives[id1] = primitive1
      newPrimitives[id2] = primitive2
      breakComplexity(newPrimitives, newPrimitives)
    }
  }
}

const getInitRootAndPrimitives = (sql: string): {rootSql: string; primitives: {[key: string]: string}} => {
  const inRegex = /\w+ IN \([^\(].*?\)/
  const primitives = {}
  let match = inRegex.exec(sql)
  let index = 1
  while (match != null) {
    const id = '<id' + index + '>'
    ;(primitives as any)[id] = match[0]
    sql = sql.replace(match[0], id)
    match = inRegex.exec(sql)
    index++
  }

  return {rootSql: sql, primitives: primitives}
}

const cleanUp = (primitives: {[key: string]: string}): {[key: string]: string} => {
  const newPrimitives = {...primitives}
  for (const prim in primitives) {
    if (
      newPrimitives[prim].indexOf(' AND ') == -1 &&
      newPrimitives[prim].indexOf(' OR ') == -1 &&
      newPrimitives[prim].indexOf(' IN ') == -1
    ) {
      newPrimitives[prim] = newPrimitives[prim]
    }
    const match = newPrimitives[prim].match(/(<id\d+>)/)
    if (match && match[0] == newPrimitives[prim]) {
      const key = newPrimitives[prim]
      newPrimitives[prim] = newPrimitives[key]
      delete newPrimitives[key]
    }
    newPrimitives[prim] = newPrimitives[prim].replace(/\(/g, '').replace(/\)/g, '')
  }
  return newPrimitives
}

const getPrimitives = (sql: string): {[key: string]: string} => {
  let rootAndPrimitives = getInitRootAndPrimitives(sql)
  const brakets = getBrakets(rootAndPrimitives.rootSql)
  rootAndPrimitives = handleBrakets(brakets, rootAndPrimitives)

  const newPrimitives = {...rootAndPrimitives.primitives, root: rootAndPrimitives.rootSql}
  const primitives = {...newPrimitives}
  breakComplexity(primitives, newPrimitives)
  return cleanUp(newPrimitives)
}

const joinOperators = {' OR ': 'Or', ' AND ': 'And'}
const operators = {
  ' = ': 'PropertyIsEqualTo',
  ' > ': 'PropertyIsGreaterThan',
  ' < ': 'PropertyIsLessThan',
  ' >= ': 'PropertyIsGreaterThanOrEqualTo',
  ' <= ': 'PropertyIsLessThanOrEqualTo',
  ' LIKE ': 'PropertyIsLike'
}

const getSimpleFilter = (filter: string, layerInfo: IFeatureLayerInfo): string => {
  for (const operator in operators) {
    if (filter.indexOf(operator) != -1) {
      const split = filter.split(operator)
      const fieldInfo = layerInfo.fields[split[0]]
      const value = split[1]
      return `<${(operators as any)[operator]}><PropertyName>${fieldInfo.fieldName}</PropertyName><Literal>${value}</Literal></${(operators as any)[operator]}>`
    } else {
      if (filter.indexOf(' IN ') != -1) {
        const split = filter.split(' IN ')
        const fieldInfo = layerInfo.fields[split[0]]
        const values = split[1]
          .replace(/\(/g, '')
          .replace(/\)/g, '')
          .split(',')
          .map(v => v.trim())
        const orFilters: Array<string> = []
        orFilters.push('<Or>')
        values.forEach(v => {
          orFilters.push(
            `<PropertyIsEqualTo><PropertyName>${fieldInfo.fieldName}</PropertyName><Literal>${v}</Literal></PropertyIsEqualTo>`
          )
        })
        orFilters.push('</Or>')
        return orFilters.join('\n')
      }
    }
  }
  throw new Error('Not implemented')
}

const loopWhereNodes = (
  rootPrimitive: string,
  primitives: {[key: string]: string},
  layerInfo: IFeatureLayerInfo
): string => {
  let joinOperator = ''
  const splitFilters = {filter1: '', filter2: ''}
  for (const op in joinOperators) {
    if (rootPrimitive.indexOf(op) != -1) {
      joinOperator = (joinOperators as any)[op]
      const split = rootPrimitive.split(op)
      splitFilters.filter1 = split[0]
      splitFilters.filter2 = split[1]
    }
  }
  if (joinOperator) {
    if (primitives[splitFilters.filter1]) {
      splitFilters.filter1 = primitives[splitFilters.filter1]
    }
    if (primitives[splitFilters.filter2]) {
      splitFilters.filter2 = primitives[splitFilters.filter2]
    }
    return `
            <${joinOperator}>
                ${loopWhereNodes(splitFilters.filter1, primitives, layerInfo)}
                ${loopWhereNodes(splitFilters.filter2, primitives, layerInfo)}
            </${joinOperator}>
        `
  } else {
    if (primitives[rootPrimitive]) {
      rootPrimitive = primitives[rootPrimitive]
      return loopWhereNodes(rootPrimitive, primitives, layerInfo)
    }
    return getSimpleFilter(rootPrimitive, layerInfo)
  }
}

export const cqlToXmlStringFilter = (query: IQuery, layerInfo: IFeatureLayerInfo): string => {
  const primitives = getPrimitives(query.where)

  return loopWhereNodes(primitives['root'], primitives, layerInfo)
}
